import styled, { css } from 'styled-components';
import { Gray, Blue } from '../../colors';
import { Paragraph } from '../typographies';
const borderGray = css `
    border: 1px solid ${Gray.normal};
`;
const borderBlue = css `
    border: 2px solid ${Blue[2]};
`;
const rotateIcon = css `
    color: ${Blue[2]};
    transform: rotate(90deg);
`;
export const CollapsibleContainer = styled.div `
    border-radius: 2px;
    transition: all .5s ease;
    overflow: hidden;
    ${({ isOpen }) => isOpen ? borderBlue : borderGray};
    ${({ isElevated }) => isElevated && css `
        border: none;
        box-shadow: 0px 4px 12px rgba(86, 90, 97, 0.12);
        border-radius: 8px;
    `}
`;
export const CollapsibleHead = styled.div `
    padding: 15px 20px;
    display: flex;
    position: relative;
    flex-direction: row;
    cursor: pointer;
    align-items: center;
    ${({ isReversed }) => isReversed && css `
        justify-content: space-between;
        flex-direction: row-reverse;
    `}

    &:hover {
        background-color: ${Blue[5]};
    }

    p {
        margin: 0;
    }

    svg {
        transition: all .5s ease;
        margin-right: 15px;
        ${({ isOpen }) => isOpen && rotateIcon};
    }

    ${Paragraph} {
        font-weight: 500;
    }
`;
export const CollapsibleContentContainer = styled.div `
    transition: max-height .5s ease-out;
    max-height: ${({ isOpen }) => isOpen ? '100vh' : 0};
`;
export const CollapsibleContent = styled.div `
    padding: 10px;
`;
export const LineSeparator = styled.div `
    left: 2%;
    height: 1px;
    bottom: -1px;
    position: absolute;
    background-color: ${Gray.normal};
    width: ${({ isOpen }) => isOpen ? '96%' : '0'};
`;
export const TitleContainer = styled.div `
    display: flex;
    flex-direction: row;
    align-items: center;
`;
export const TitleTextContainer = styled.div `
    margin-left: 10px;
`;
//# sourceMappingURL=collapsible.styled.js.map